
/**
 * Gets the appropriate marker icon color based on rating
 */
export const getMarkerIconColor = (rating: number): string => {
  if (rating <= 2.5) return '#ea384c'; // Red for low ratings
  if (rating <= 3.5) return '#F97316'; // Orange for medium ratings
  return '#22c55e'; // Green for high ratings
};

/**
 * Creates a consistent location key based on coordinates
 */
export const createLocationKey = (lat: number, lng: number): string => {
  return `${Number(lat).toFixed(4)}-${Number(lng).toFixed(4)}`;
};
